<app-admin-dashboard>
  <app-contact-info/>
</app-admin-dashboard>